import { IVisaPrepForm } from '../../../../../../types';

type Fields = Pick<IVisaPrepForm, 'hasBeenDeported' | 'deportations'>;

type Params = Fields;

export function getPageStatus({ hasBeenDeported, deportations }: Params): { complete: boolean } {
  let complete = false;
  if (hasBeenDeported === false) {
    complete = true;
  } else if (hasBeenDeported === true) {
    if (!deportations || deportations.length === 0) {
      complete = false;
    } else {
      complete = !deportations.some(deportation => {
        return (
          deportation.country === '' ||
          deportation.airport === '' ||
          deportation.reason === '' ||
          deportation.removalDate === ''
        );
      });
    }
  }

  return { complete };
}
